<template>
    <a-modal v-model="visible" title="查看" width="900px" cancel-text="关闭" class="viewFormula" destroyOnClose
        @cancel="onModalCancel">
        <section>
            <p>基础信息</p>
            <div class="section-body">
                <a-row :gutter="[16, 24]">
                    <a-col :span="4" class="aligh-right">
                        期间：
                    </a-col>
                    <a-col :span="8">
                        {{ formulaObj.rangeName }}
                    </a-col>
                    <a-col :span="4" class="aligh-right">
                        五日测算版本号：
                    </a-col>
                    <a-col :span="8">
                        {{ formulaObj.pushVersion }}
                    </a-col>
                </a-row>
                <a-row :gutter="[16, 24]">
                    <a-col :span="4" class="aligh-right">
                        产品名称：
                    </a-col>
                    <a-col :span="8">
                        {{ formulaObj.materialName }}
                    </a-col>
                    <a-col :span="4" class="aligh-right">
                        产品编码：
                    </a-col>
                    <a-col :span="8">
                        {{ formulaObj.materialCode }}
                    </a-col>
                </a-row>
                <a-row :gutter="[16, 24]">
                    <a-col :span="4" class="aligh-right">
                        配方名称：
                    </a-col>
                    <a-col :span="8">
                        {{ formulaObj.formulaName }}
                    </a-col>
                    <a-col :span="4" class="aligh-right">
                        配方代码：
                    </a-col>
                    <a-col :span="8">
                        {{ formulaObj.formulaCode }}
                    </a-col>
                </a-row>
                <a-row :gutter="[16, 24]">
                    <a-col :span="4" class="aligh-right">
                        版本：
                    </a-col>
                    <a-col :span="20">
                        {{ formulaObj.productVersion }}
                    </a-col>
                </a-row>
            </div>
        </section>
        <section>
            <p>配方明细</p>
            <a-table :columns="columns" :data-source="tableData" :pagination="false" rowKey="id"
                :scroll="{ x: 840, y: 350 }">
                <span slot="isExtraRaw" slot-scope="text" :style="{ color: text == 0 ? 'red' : 'green' }">
                    {{ text == 0 ? '否' : '是' }}
                </span>
            </a-table>
        </section>

        <template slot="footer">
            <div style="height: 40px;line-height: 40px;">
                <a-button style="height: 32px;width: 66px;" @click="onModalCancel">关闭</a-button>
            </div>
        </template>
    </a-modal>
</template>

<script>
const columns = [
    {
        title: '原料名称',
        dataIndex: 'rawName',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '原料代码',
        dataIndex: 'rawCode',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '价格',
        dataIndex: 'rawPrice',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '配方用量(%)',
        dataIndex: 'nhfRawPercentage',
        align: 'center',
        ellipsis: true,
    },
    {
        title: 'EBS用量(%)',
        dataIndex: 'ebsRawEditWeight',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '影子价格下限',
        dataIndex: 'minShadowPrice',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '影子价格上限',
        dataIndex: 'maxShadowPrice',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '是否额外添加',
        dataIndex: 'isExtraRaw',
        align: 'center',
        ellipsis: true,
        scopedSlots: { customRender: 'isExtraRaw' }
    },
];

export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        formulaObj: {
            type: Object,
            default: () => { },
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.getTableData();
            }
        },
    },
    data() {
        return {
            columns,
            tableData: [],
        };
    },
    mounted() { },
    methods: {
        async getTableData() {
            let params = {
                monthFormulaId: this.formulaObj.id,
                current: 1,
                size: 1000,
            };
            let res = await this.$http.get('/nhf-app/fridaycalculatemonthplanformularaw/list', {
                params,
            });
            if (res.code == 200) {
                this.tableData = res.data.records || [];
            }
        },
        onModalCancel() {
            this.$emit('close');
        }
    },
};
</script>

<style lang="scss">
.viewFormula {
    .ant-modal-body {
        padding: 0 24px 24px 24px;
    }

    section {
        >p {
            font-weight: bold;
            margin-top: 16px;
        }

        .aligh-right {
            text-align: right;
        }
    }
}
</style>